import { useTranslation } from 'react-i18next';
import { Calculator, ListFilter, GitCompareArrows, FileCheck2 } from 'lucide-react';
import { MethodologyLink } from './LandingActions';

const CAPABILITIES = [['estimate', Calculator], ['explain', ListFilter], ['compare', GitCompareArrows], ['decide', FileCheck2]];
export const Capabilities = () => {
  const { t } = useTranslation();
  return <section className="lp-section" data-testid="landing-capabilities" aria-labelledby="landing-capabilities-title">
    <div className="lp-container">
      <h2 id="landing-capabilities-title" data-testid="landing-capabilities-title">{t('homepage.capabilities.heading')}</h2>
      <p className="lp-section-intro" data-testid="landing-positioning">{t('homepage.positioning')}</p>
      <div className="lp-capabilities-grid">
        {CAPABILITIES.map(([key, Icon], index) => <article key={key} data-testid={`landing-capability-${key}`}>
          <div className="lp-capability-marker"><Icon size={22} aria-hidden="true" /><span>0{index + 1}</span></div>
          <h3>{t(`homepage.capabilities.${key}.title`)}</h3>
          <p>{t(`homepage.capabilities.${key}.body`)}</p>
        </article>)}
      </div>
      <p className="lp-small-note" data-testid="landing-account-note">{t('homepage.accountNote')}</p>
    </div>
  </section>;
};

const PROVENANCE = ['user', 'default', 'modelled', 'iso'];
export const TrustSection = () => {
  const { t } = useTranslation();
  return <section className="lp-section lp-trust" data-testid="landing-trust" aria-labelledby="landing-trust-title">
    <div className="lp-container lp-trust-layout">
      <div>
        <h2 id="landing-trust-title" data-testid="landing-trust-title">{t('homepage.trust.heading')}</h2>
        <p className="lp-section-intro" data-testid="landing-trust-description">{t('homepage.trust.body')}</p>
        <MethodologyLink placement="trust" />
      </div>
      <dl className="lp-provenance-list" x-excluded="true">
        {PROVENANCE.map(key => <div key={key} className="lp-provenance-row" data-testid={`landing-provenance-${key}`}>
          <dt><span className={`lp-provenance-tag lp-provenance-${key}`}>{t(`homepage.trust.${key}.label`)}</span></dt>
          <dd>{t(`homepage.trust.${key}.body`)}</dd>
        </div>)}
      </dl>
      <p className="lp-trust-caveat" data-testid="landing-confidence-caveat">{t('homepage.trust.caveat')}</p>
    </div>
  </section>;
};

export const AudienceSection = () => {
  const { t } = useTranslation();
  return <section className="lp-section lp-audience" data-testid="landing-audience" aria-labelledby="landing-audience-title">
    <div className="lp-container">
      <h2 id="landing-audience-title" data-testid="landing-audience-title">{t('homepage.audience.heading')}</h2>
      <dl className="lp-audience-grid" x-excluded="true">
        {['ciso', 'cfo', 'consultant'].map(key => <div key={key} className="lp-audience-row" data-testid={`landing-audience-${key}`}>
          <dt>{t(`homepage.audience.${key}.title`)}</dt><dd>{t(`homepage.audience.${key}.body`)}</dd>
        </div>)}
      </dl>
    </div>
  </section>;
};